import React from "react";

export default function Footer(){

    return(
        <footer>
            {/* Footer */}
            <div className="myFooter">

                <span className="copyright"> &copy; 2024 Manpreet Kaur </span>

            </div>
            
        </footer>
    )
}